import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Property } from "./property.model";

/**
 * @class SmsTransaction
 *
 */
export class SmsTransaction extends Model {

    static get COEF() {

        return 0.044; //price for single SMS
    }

    static get PAYMENT_METHOD_CC() {

        return 1;
    }

    static get PAYMENT_METHOD_PAYPAL() {

        return 2;
    }

    static get PAYMENT_METHOD_SADAD() {

        return 3;
    }

    static get PAYMENT_METHOD_CASH() {

        return 4;
    }

    static get PAYMENT_METHOD_CHEQUE() {

        return 5;
    }

    static get PAYMENT_METHOD_POS() {

        return 6;
    }

    static get PAYMENT_METHOD_BANK() {

        return 7;
    }

    static get validationModel() {

        return {
            sms: {
                label: 'SMS_UNITS_TO_PURCHASE',
                messages: {
                    notLessThan: 'THE_ENTERED_VALUE_SHOULD_BE_GREATER_THAN_O',
                    maxSmsValue: 'MAX_VALUE_EXCEEDED',
                }
            }
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'user', 'user_id', 'user_name', 'payment_method', 'payment_method_name', 'status', 'sms', 'amount', 'total_amount', 'date', 'invoice',
    'cheque_number', 'bank', 'reference_number', 'cc_type', 'cc_number', 'cardholder_name', 'cc_month', 'cc_year', 'cc_cvv', 'sadad_username', 'paytabs_transaction')(SmsTransaction);


// WEBPACK FOOTER //
// ./src/pms-api/models/sms-transaction.model.js